import "./App.css";
import { Route, BrowserRouter } from "react-router-dom";
import Navbar from "./components/Navigation";
import React, { Component } from "react";
import portfolio from "./components/portfolio";
import about from "./components/about";
import contact from "./components/contact";
import welcome from "./components/welcome";
import ScrollToTop from "./components/scroll";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <BrowserRouter>
        <div className="App">
          <Navbar />
          <div id="main">
            <ScrollToTop>
              <Route exact path="/" component={welcome} />
              <Route exact path="/portfolio" component={portfolio} />
              <Route exact path="/about" component={about} />
              <Route exact path="/contact" component={contact} />
            </ScrollToTop>
          </div>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
